import { LOAD } from '@/config/app'

/*
// start the sound loading like this.
// this loads the "main" group by default.
SoundService.load(soundManifest)

// specify a different group:
SoundService.load(soundManifest, 'intro')

// get a sound
let bloop = SoundService.get(SOUND_URLS.placeholder1)

// play a sound
bloop.play()
*/

export const CRITICAL_SOUNDS = {}

export const MAIN_SOUNDS = {
	empty: require(`@/assets/audio/250-milliseconds-of-silence.mp3`),

	ambientEpoch1: require(`@/assets/audio/ambient/Chapter1AudioLoop.mp3`),
	ambientEpoch2: require(`@/assets/audio/ambient/Chapter2AudioLoop.mp3`),
	ambientEpoch3: require(`@/assets/audio/ambient/Chapter3AudioLoop.mp3`),

	buttonClick: require(`@/assets/audio/sfx/ButtonClick.mp3`),
	buttonHover: require(`@/assets/audio/sfx/ButtonHover.mp3`),
}

export const EPOCH_4_SOUNDS = {
	ambientEpoch4: require(`@/assets/audio/ambient/Chapter4AudioLoop.mp3`),
}

export const VOICE_OVERS = {
	epoch1: require(`@/assets/audio/voiceovers/Chapter1VoiceOver.mp3`),
	epoch2: require(`@/assets/audio/voiceovers/Chapter2VoiceOver.mp3`),
	epoch3: require(`@/assets/audio/voiceovers/Chapter3VoiceOver.mp3`),
	epoch4: require(`@/assets/audio/voiceovers/Chapter4VoiceOver.mp3`),
}

export const SOUND_URLS = {
	...CRITICAL_SOUNDS,
	...MAIN_SOUNDS,
	...EPOCH_4_SOUNDS,
}

export default [
	{
		id: LOAD.GROUPS.CRITICAL,
		urls: Object.values(CRITICAL_SOUNDS),
	},
	{
		id: LOAD.GROUPS.MAIN,
		urls: Object.values(MAIN_SOUNDS),
	},
	{
		id: LOAD.GROUPS.EPOCH_4,
		urls: Object.values(EPOCH_4_SOUNDS),
	},
]
